import { Card, CardBody, Col, Container, Row } from 'react-bootstrap';
import { Outlet } from 'react-router-dom'
import { ToastProvider } from 'context/ToastContext';
import { AuthProvider } from 'context/AuthContext';
import { useTheme } from 'context/ThemeContext';
import SolarMoonBoldDuotone from 'components/icons/SolarMoonBoldDuotone';
import SolarSun2BoldDuotone from 'components/icons/SolarSun2BoldDuotone';
 
const LoginLayout = () => {
    const { darkTheme, setDarkTheme } = useTheme();

    return (
        <div className="auth-main">
            <button
                type="button"
                className="auth-theme-toggle"
                onClick={() => setDarkTheme(!darkTheme)}
                aria-label={darkTheme ? 'Enable light theme' : 'Enable dark theme'}
                title={darkTheme ? 'Light theme' : 'Dark theme'}
            >
                {darkTheme ? <SolarSun2BoldDuotone /> : <SolarMoonBoldDuotone />}
            </button>
            <div className="auth-wrapper v1 justify-content-center">
                <div className="auth-form">
                    <Card className="my-5">
                        <Card.Body>
                            <Outlet/>
                        </Card.Body>
                    </Card>
                </div>
            </div>

        </div>
    );
};

export default LoginLayout;
